export const loginState = {
  login: 'signIn',
  loginOut: 'signOut',
  configured: 'configured',
};
